export default {
  title: "",
  subtitle: "",
  path: "settlements_and_deposit_prefunding",
  paragraphs: [
   "For deposits/pre-funding, the logic is the same: the bank_accounts_ids used will be from FacilitaPay’s international bank account as the source and your cash_out internal account as the destination."
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload:
    { 
    "transaction": { 
        "currency": "USD", 
        "exchange_currency": "USD", 
        "value": "100000.00", 
        "from_bank_account_id": "FacilitaPay international account_id", 
        "to_bank_account_id": "your cash-out USD", 
        "subject_id": "your partner_id" 
        } 
    } 
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionSettlementsDepositFunding.js